import styled from 'styled-components';

import { Loader as LoaderLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  margin-top: 75px;
  max-width: 400px;
  width: auto;
`;

const Logo = styled.img`
  margin-bottom: 90px;
  max-width: 200px;
`;

const Loader = styled(LoaderLayoutComponent)`
  margin-top: 45px;
`;

const Title = styled(TextLayoutComponent.Title)`
  margin-top: 45px;
`;

const Text = styled(TextLayoutComponent)`
  align-items: center;
`;

const CenterText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export {
  Container,
  Loader,
  Logo,
  Text,
  Title,
  CenterText,
};
